import { Component, ViewEncapsulation } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  templateUrl: 'save-changes.dialog.html',
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class SaveChangesComponent {
  constructor(private readonly dialogRef: MatDialogRef<SaveChangesComponent>) {}

  cancel() {
    this.dialogRef.close(false);
  }

  leave(): void {
    this.dialogRef.close(true);
  }
}
